import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { AuthProvider } from './hooks/useAuth';
import { ProtectedRoute } from './components/auth/ProtectedRoute';
import { Login } from './pages/Login';
import { Register } from './pages/Register';
import { UserConfigPage } from './pages/UserConfig';
import { GlobalConfig } from './pages/GlobalConfig';
import { LogsViewerPage } from './pages/LogsViewerPage';
import { Performance } from './pages/Performance';
import './lib/amplify'; // Initialize Amplify
import { Toaster } from './components/ui/toaster';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 1,
      staleTime: 5 * 60 * 1000, // 5 minutes
    },
  },
});

function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <AuthProvider>
        <Router>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />
            <Route path="/" element={<Navigate to="/performance" replace />} />
            <Route 
              path="/performance" 
              element={
                <ProtectedRoute requireApproved>
                  <Performance />
                </ProtectedRoute>
              } 
            />
            <Route 
              path="/config" 
              element={
                <ProtectedRoute requireApproved>
                  <UserConfigPage />
                </ProtectedRoute>
              } 
            />
            <Route 
              path="/global-config" 
              element={
                <ProtectedRoute requireApproved>
                  <GlobalConfig />
                </ProtectedRoute>
              } 
            />
            <Route 
              path="/logs" 
              element={
                <ProtectedRoute requireApproved>
                  <LogsViewerPage />
                </ProtectedRoute>
              } 
            />
            <Route path="*" element={<Navigate to="/performance" replace />} />
          </Routes>
        </Router>
        <Toaster />
      </AuthProvider>
    </QueryClientProvider>
  );
}

export default App;
